<div class="banner">
    <ng-content></ng-content>
</div>
